import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const GsisCallback = () => {
  if (import.meta.env.MODE === "development") {
    window.serverData = {
      status: "success",
      data: {
        token:
          "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIxMzA2NzM2ODciLCJuYmYiOjE3NTg2MTQ2OTAsImV4cCI6MTc1ODYxNDk5MCwiaWF0IjoxNzU4NjE0NjkwfQ.PnybKFXQ0tFM3VO4PzP8PSjCiAhEnY1gTIR09GK6A2I",
      },
    };
  }

  const [data] = useState(window.serverData || {});
  const navigate = useNavigate();

  useEffect(() => {
    if (data.status === "success") {
      navigate("/amka-login");
    } else {
      navigate("/error");
    }
  }, [data]);

  return (
    <div>
      <p>Processing, please wait...</p>
    </div>
  );
};

export default GsisCallback;
